import React from "react";
import { PROPERTIES, SELLERS, HSC_HOTLIST_SELLERS } from "../../consts/tables";
import { SELLERS_LIST_COUNT } from "../../consts/queries";
import CRUD from "../CRUD/CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import { browserHistory } from "react-router";
import { getData, manageData } from "../../requests/CRUD";
import SellerInfo from "./SellerInfo";
import SellerCompanyInfo from "./SellerCompanyInfo";
import { dateISOtoUS, dateUStoISO } from "../../date-converter";
import Drawer from "../Drawer";
import PropertyDrawer from "../PropertyDrawer/PropertyDrawer";
import PropertyInfo from "../CRUDProperty/components/PropertyInfo";
import {formatAddress, formatNumber} from "../../utils";
import { priceToString } from "../CRUDProperty/CRUDProperty";
import request from 'arcdynamic-request';
import { executeQuery } from "../../requests/executeQuery";

const limit = 1000;

const dateProps = [
  "LAST_MODIFIED"
];

const propertyPriceProps = [
  'LIST_PRICE',
  'HSC_PRICE'
];

function convertPropertyDataToForm(dbData) {
  const data = {...dbData};

  propertyPriceProps
    .filter((key) => data[key])
    .forEach((key) => {
        const num = Number(data[key]);
        if (num === num) {
            data[key] = formatNumber(num,true);
        }
    }); 

  return data;
}

function convertDataToForm(dbData) {
  const data = {...dbData};

  dateProps
      .filter(key => data[key])
      .forEach(key => {
          const str = dateISOtoUS(data[key]);
          if (str !== false)
              data[key] = str;
      });

  return data;
}

function convertFormToData(formData) {
  const data = {...formData};

  dateProps
      .filter(key => data[key])
      .forEach(key => {
          const str = dateUStoISO(data[key]);
          if (str !== false)
              data[key] = str;
      });

  propertyPriceProps.forEach((key) => {
          const num = priceToString(data[key]);
          if (num !== false)
              data[key] = num;
      });      


  return data;
}

export default class CRUDSeller extends React.Component {
  drawerComponentRef;

  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      isExists:false,
      errorTabs: [],
      users:[],
      currentTab: 0,
      showDrawer:false,
      offMarketProperty:null,
      updateSeller: false,
      updateProperty: false,
      viewMode: this.props.edit || false,
      resetDrawer: false,
      loggedInUserData:{},
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeInput = this.handleChangeInput.bind(this);
    this.saveData = this.saveData.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.handlePropertyChangeInput = this.handlePropertyChangeInput.bind(this);
    this.handlePropertyChangeDropdown = this.handlePropertyChangeDropdown.bind(this);
    this.savedNewItem = this.savedNewItem.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);

    this.drawerComponentRef = React.createRef();
  }
  
  savedNewItem(newData) {
    const state = {
      offMarketProperty: {...newData},
    };
    this.setState(state, () => this.toggleDrawer());
    this.fetch(this.props.params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }

  componentDidMount() {
    this.setState({loggedInUserData: this.props.userData});
    this.fetch(this.props.params.id);
  }

  closeDrawer() {
    this.setState({showDrawer: false, resetDrawer: true});
  }

  toggleDrawer() {
    this.setState((prevState) => ({showDrawer: !prevState.showDrawer, resetDrawer: false}));
  }

  fetch(id) {
    const loggedInUserData = this.props.userData;
    this.setState({
      data: null,
      error: null,
      success: null,
    });

    if (id === undefined) {
      this.setState({
        data: {},
      });
      return;
    }

    return Promise.all([
      getData({
        tableCode: SELLERS,
        options: {
          filter: [
          {
            text: id,
            code: "ARCIMEDES_ROW_ID",
            type: "exact",
          },
          ],
        },
      }),
      getData({
        tableCode: PROPERTIES,
        options: {
          filterType:'and',
          filter: [
            {
              text: 'Off Market',
              code: "STATUS",
              type: "exact",
            },
            {
              text: id,
              code: "SELLER_ID",
              type: "exact",
            },
          ],
          order: [{ code: 'ARCIMEDES_ROW_ID', type: 'asc'  }],
          limit: { count: 3, offset: 0 },
        },
        
      })
    ]).then(async res => {
      if (res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length 
        &&res[1] && res[1].success && Array.isArray(res[1].data) && res[1].data.length) {
          const {ARCIMEDES_ROW_ID} = res[0].data[0];
          const responseData = {...res[0].data[0]};
          let HSC_FOLLOW_UP = '';

          const fetchHSCFollowup = await this.getSellerAssignedToHSCAgent(ARCIMEDES_ROW_ID.toString())
          if(Object.keys(fetchHSCFollowup).length && fetchHSCFollowup.SELLER_ID===ARCIMEDES_ROW_ID.toString()) {
              HSC_FOLLOW_UP = fetchHSCFollowup.HSC_AGENT_ID ? fetchHSCFollowup.HSC_AGENT_ID :''
          }

          responseData.HSC_FOLLOW_UP = HSC_FOLLOW_UP;                
          const followUpList = HSC_FOLLOW_UP ? HSC_FOLLOW_UP.split(',') : [];
          responseData['HSC_HOT_LIST'] = followUpList.includes(loggedInUserData.email) ? '1' : '0';
          
        this.setState({
          data: convertDataToForm(responseData),
          offMarketProperty: convertPropertyDataToForm(res[1].data),
          original: { ...convertDataToForm(responseData) },
          error: null,
        });
      } 
      else if(res[0] && res[0].success && Array.isArray(res[0].data) && res[0].data.length){
        const {ARCIMEDES_ROW_ID} = res[0].data[0];
          const responseData = {...res[0].data[0]};
          let HSC_FOLLOW_UP = '';

          const fetchHSCFollowup = await this.getSellerAssignedToHSCAgent(ARCIMEDES_ROW_ID.toString())
          if(Object.keys(fetchHSCFollowup).length && fetchHSCFollowup.SELLER_ID===ARCIMEDES_ROW_ID.toString()) {
              HSC_FOLLOW_UP = fetchHSCFollowup.HSC_AGENT_ID ? fetchHSCFollowup.HSC_AGENT_ID :''
          }

          responseData.HSC_FOLLOW_UP = HSC_FOLLOW_UP;                
          const followUpList = HSC_FOLLOW_UP ? HSC_FOLLOW_UP.split(',') : [];
          responseData['HSC_HOT_LIST'] = followUpList.includes(loggedInUserData.email) ? '1' : '0';
          

        this.setState({
          data: convertDataToForm(responseData),
          original: { ...convertDataToForm(responseData) },
          error: null,
        });
      }
      else {
        this.setState({
          data: false,
          offMarketProperty: false,
          error: res[0].message ? res[0].message : "Unidentified Error",
        });
      }
    });
  }
  fetchUserData(){
    executeQuery({queryName: SELLERS_LIST_COUNT})
    .then((res)=>{
      let totalRequest = Math.round(res.data[0].TOTAL_COUNT/1000);
      let requests = [];
      let offset = 0;
      for(let i=totalRequest; i>0;i--){
        requests.push(request(arc.path.api, {
          service: "arcimedes",
          action: "open.datasource.table.Data.getData",
          params: [
            "code",
            SELLERS,
            {
              limit: {
                count: limit,
                offset: offset * limit,
              },
              column: [                                
                'ARCIMEDES_ROW_ID',
                'FIRST_NAME',
                'LAST_NAME',
                'EMAIL',
                'PHONE',
                'DELETED',
              ],
              filterType: "and",
              filter: [
                {
                  code: "DELETED",
                  text: "",
                  type: "null",
                },
              ],
              order: [
                {
                  code: "FIRST_NAME",
                  type: "asc",
                },
                {
                  code: "LAST_NAME",
                  type: "asc",
                },
              ],
            },
          ],
        }));
        ++offset;
      }
    Promise.all(requests).then((res) => {
      if(res){
        var users = []
        res.forEach((resp)=>{
          if(resp && resp.success){
            users = [...users, ...resp.data]
          }
        })
        users = users.filter(user => user.FIRST_NAME !== '' || user.LAST_NAME !== '')
        this.setState({users});
        const isExists = this.state.users.some(user => {
          if (
            this.state.data.ARCIMEDES_ROW_ID &&
            user.ARCIMEDES_ROW_ID === this.state.data.ARCIMEDES_ROW_ID
          ) {
            return false;
          }
          return (                
            (user.FIRST_NAME != null && user.FIRST_NAME.toLowerCase()) === (this.state.data.FIRST_NAME != null && this.state.data.FIRST_NAME.toLowerCase()) &&
            (user.LAST_NAME != null && user.LAST_NAME.toLowerCase()) === (this.state.data.LAST_NAME != null && this.state.data.LAST_NAME.toLowerCase())
          );
        });
  
        this.setState({
          isExists: !!isExists,
        });
  
        if (isExists) {
          return;
        } else {
          this.setState({ viewMode: true }, () => this.saveData());
        }

      }
      })
    })
  }
  async getSellerAssignedToHSCAgent(sellerId = '') {
      try {
          const res = await getData({
              tableCode: HSC_HOTLIST_SELLERS,
              options: {
                  filter: [{
                      text: sellerId,
                      code: "SELLER_ID",
                      type: "exact",
                  }],
              },
          });
          const result = res && res.data.length && res.data[0];
          this.setState({HscFollowUpData: result})
          return result;
      } catch (error) {
          throw error; 
      }
  }
  async handleSubmit(e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (
      !this.state.data.FIRST_NAME ||
      !this.state.data.LAST_NAME
    ) {
      this.setState({ errorTabs: [0], success: null });
      return;
    } else {
      if (this.state.isBusy || this.state.viewMode === true) return;
      this.setState({ errorTabs: [] });
      this.fetchUserData();
    }


  }

  /* handleChangeInput(key, value) {
    this.setState({
      data: Object.assign(this.state.data, {
        [key]: value
      }),
      updateSeller:true
    });
  } */
    handleChangeInput(key, value) {
      this.setState((prevState) => {
          let newValue = key === "HSC_HOT_LIST" ? (prevState.data[key] === "1" ? "0" : "1") : value;
  
          return {
              data: {
                  ...prevState.data,
                  [key]: newValue,
              },
              updateSeller: true,
          };
      });
  }
  

  handleChangeDropdown(query, queryType, x, key) {
    const data = {...this.state.data};
        if (key === 'STATUS') {
            data.LAST_MODIFIED = new Date().toLocaleDateString("en-US");
        }
      data[key] = query[key];
      this.setState({
        data:data,
        updateSeller:true
      });
  }

  handlePropertyChangeInput(key, value) {
    this.setState({
      offMarketProperty: Object.assign(this.state.offMarketProperty, {
        [key]: value
      }),
      updateProperty:true
    });
  }

  handlePropertyChangeDropdown(query, queryType, x, key) {
    const data = {...this.state.offMarketProperty};
    data[key] = query[key];
    this.setState({
      offMarketProperty:data,
      updateProperty:true
    });
  }

  saveData(directDelete=false) {
   // const loggedInUserId = this.state.loggedInUserData.id;
   const loggedInUserEmail = this.state.loggedInUserData.email;
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    const offMarketProperty = convertFormToData(this.state.offMarketProperty);
    offMarketProperty.ADDRESS = offMarketProperty.ADDRESS ? formatAddress(offMarketProperty.ADDRESS) : '';

    Object.keys(this.state.data).forEach((k) => {
      if (!this.state.data[k] || k === "undefined") {
        const newData = { ...this.state.data };
        delete newData[k];
        this.setState({ data: newData });
      }
    });
    let formattedState = {...this.state.data}
        let hotlist;
        if (formattedState["HSC_HOT_LIST"] === "1") {         
             if (formattedState["HSC_FOLLOW_UP"]) {
                const followUpList = formattedState["HSC_FOLLOW_UP"].split(",");
                if (!followUpList.includes(loggedInUserEmail)) {
                    followUpList.push(loggedInUserEmail);
                }
                hotlist = followUpList.join(",");
            } else {
                hotlist = loggedInUserEmail;
            } 
        } else if (formattedState["HSC_HOT_LIST"] === "0") {
            if (formattedState["HSC_FOLLOW_UP"]) {
                let followUpList = formattedState["HSC_FOLLOW_UP"]
                                    .split(",")
                                    .map(email => email.trim())
                                    .filter(email => email !== loggedInUserEmail);
               // let followUpList = formattedState["HSC_FOLLOW_UP"].split(",");
                //followUpList = followUpList.filter(email => email !== loggedInUserEmail); 
                hotlist = followUpList.length > 0 ? followUpList.join(",") : ""; 
            }
        }
        delete formattedState.HSC_HOT_LIST;
        delete formattedState.HSC_FOLLOW_UP;
    return Promise.all([
        (this.state.updateSeller || directDelete) &&
        manageData({ tableCode: SELLERS, 
          data: [convertFormToData(formattedState)],
        }),
        this.state.updateProperty &&
        manageData({tableCode: PROPERTIES,
          data: [offMarketProperty]})
      ]).then((res) => {
        if ((res[0] && res[0].success) || (res[1] && res[1].success)) {
          const sellerRow = res[0] && res[0].data && res[0].data[0];
          const sellerId = sellerRow ? sellerRow.ARCIMEDES_ROW_ID : (this.state.data && this.state.data.ARCIMEDES_ROW_ID);
          
          const hotlistPayload = {
            ...(this.state.HscFollowUpData || {}),
            SELLER_ID: sellerId ? sellerId.toString() : '',
            HSC_AGENT_ID: hotlist
          };

          manageData({
              tableCode: HSC_HOTLIST_SELLERS,
              data: [hotlistPayload],
          }).then((hotlistRes)=>{
              this.setState({
                isBusy: false,
                success: "Saved",
                updateProperty: false,
                updateSeller: false,
                offMarketProperty: offMarketProperty,
                HscFollowUpData: hotlistRes && hotlistRes.success && hotlistRes.data && hotlistRes.data[0] ? hotlistRes.data[0] : this.state.HscFollowUpData,
              }, () => {
                if (!this.props.edit && sellerId) {
                  browserHistory.push({
                    pathname: `/seller/${sellerId}`,
                  });
                }
              });
          });
          window.scrollTo(0, 0);
        } else {
            this.setState({
              isBusy: null,
              error: res[0] && res[0].message ? res[0].message : (this.state.updateSeller ? "Unspecified error":"No changes were made"),
              updateProperty: false,
              updateSeller: false,
            });
        }
      }
    );
  }

  render() {
    const data = this.state.data;
    const { edit } = this.props;
    const tabsData = [
      {
        name: "SELLER",
        renderedComponent: (
            <SellerInfo
                data={data}
                isExists={this.state.isExists}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
                toggleDrawer={this.toggleDrawer}
            />
        ),
      },
      {
        name: "SELLER COMPANY",
        renderedComponent: (
            <SellerCompanyInfo
                data={data}
                handleChangeInput={this.handleChangeInput}
                handleChangeDropdown={this.handleChangeDropdown}
                viewMode={this.state.viewMode}
                deleted={data && data.DELETED === "1"}
            />
        ),
      }
    ];
    
    if (data && data.STATUS === 'Off-Market' && this.state.offMarketProperty){      
      Object.keys(this.state.offMarketProperty).forEach((e,index)=>{
        tabsData.push({
          name: "PROPERTY"+'\n'+(index+1),
          renderedComponent: (
            this.state.offMarketProperty[e] ?
                  <PropertyInfo
                      data={convertFormToData(this.state.offMarketProperty[e])}
                      handleChangeInput={this.handlePropertyChangeInput}
                      handleChangeDropdown={this.handlePropertyChangeDropdown}
                      viewMode={this.state.viewMode}
                      deleted={data && data.DELETED === "1"}
                      isOffMarket={true}
                  />
                  :
                  <div className='no-results'>The seller doesn't have any Off Market property.</div>
          ),
        });
      });
    }

    return (
      <CRUD
        tabsData={tabsData}
        isExists={this.state.isExists}
        router={this.props.router}
        backLink={`${arc.path.base}sellers`}
        edit={edit}
        state={this.state}
        setState={this.setState.bind(this)}
        handleSubmit={this.handleSubmit}
        saveData={()=>this.saveData(true)}
        type="seller"
        backName="SELLERS"
        title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
        /* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
        forceActions={editsEverySummitRecord(getCurrentAccess())}
        drawer={
          <Drawer
              isOpen={this.state.showDrawer}
              reff={this.drawerComponentRef}
              closeDrawer={this.closeDrawer}
          >
              <PropertyDrawer 
                userData = {this.props.userData}
                savedNewItem={this.savedNewItem}
                closeDrawer={this.closeDrawer}               
                isOffMarket={true}
                sellerId={this.props.params.id}  
                resetDrawer={this.state.resetDrawer}
              />
          </Drawer>
      }
      />
    );
  }
}
